<section class="bg-base-100 py-20 px-4">
  <div class="max-w-6xl mx-auto px-6 lg:px-12">
    <div class="grid order-first grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
      <div class="text-center lg:text-left">
        <h1 class="text-4xl md:text-6xl font-bold mb-6 text-base-800">Pantry</h1>
        <p class="text-xl md:text-2xl mb-8 text-base-600">Manage the stock of your food to prevent food waste.</p>
        <app-auth-button class="col" [returnUrl]="redirectUri"></app-auth-button>
      </div>
      <div class=" lg:order-last">
        <img src="/assets/img/pantry_landing_small.png" class="w-full object-contain rounded-lg"/>
      </div>
    </div>
  </div>
</section>
